import React from "react";
import { Route, Redirect } from "react-router-dom";

import accessToken from "../helpers/jwt-token-access/accessToken";
import jwtDecode from "jwt-decode";

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  allowedRoles,
  //   userRole,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      const token = accessToken();
      let userRole = "";
      console.log("is token Present :: ", token);
      if (token) {
        const decoded = jwtDecode(token);
        const userName = decoded["email"];
        userRole = decoded["cognito:groups"][0];
        console.log("Token is present, userRole = ", userRole);
      } else {
        console.log("Token is not present, userRole = ", "");
      }
      console.log(
        "In Route, allowedRoles :: ",
        allowedRoles,
        " User :: ",
        userRole
      );

      if (isAuthProtected && !localStorage.getItem("authUser")) {
        console.log("Token is not found, redirecting to /login");
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      if (allowedRoles.includes(userRole)) {
        console.log("In Route", allowedRoles, " includes ", userRole);
        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }
      else {
        return <Redirect to="/access-denied" />;
      }
    }}
  />
);

export default AppRoute;
